import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type {
  ApiResponse,
  FeedbacksListResponse,
  FeedbacksFilters
} from '@/types';

export interface FeedbacksQuery extends FeedbacksFilters {
  page?: number;
  pageSize?: number;
}

export const feedbackService = {
  async list(query: FeedbacksQuery): Promise<FeedbacksListResponse> {
    const params: Record<string, string | number | boolean> = {
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20
    };
    if (query.search) params.search = query.search;
    if (query.feedbackType) params.feedbackType = query.feedbackType;
    if (query.sentiment) params.sentiment = query.sentiment;
    if (query.fromDate) params.fromDate = query.fromDate;
    if (query.toDate) params.toDate = query.toDate;
    if (query.isAddressed !== undefined) params.isAddressed = query.isAddressed;

    const res = await api.get<ApiResponse<FeedbacksListResponse>>(
      API_ENDPOINTS.FEEDBACKS.BASE,
      { params }
    );
    return res.data.data;
  },

  async listReasons(): Promise<string[]> {
    const res = await api.get<ApiResponse<string[]>>(
      API_ENDPOINTS.FEEDBACKS.REASONS
    );
    return res.data.data;
  },

  async markAddressed(id: string, note: string): Promise<void> {
    await api.patch(API_ENDPOINTS.FEEDBACKS.ADDRESS(id), { note });
  },

  async unmarkAddressed(id: string): Promise<void> {
    await api.patch(API_ENDPOINTS.FEEDBACKS.UNADDRESS(id));
  }
};
